export const JUMP_ORDER = 1024;

export const addOrRemoveFromStringArray = (key, sourceArray) => {
  if (sourceArray.includes(key)) {
    sourceArray.splice(sourceArray.indexOf(key), 1);
    return [...sourceArray];
  }
  return [...sourceArray, key];
};

export const immutablySwapItems = (list, from, to) => {
  const parsedItems = [...list];
  const fromEl = { ...parsedItems[from] };
  parsedItems.splice(from, 1);
  parsedItems.splice(to, 0, fromEl);
  const toEl = parsedItems[to];
  const beforeElOrder = parsedItems[to - 1] ? parsedItems[to - 1].order : 0;
  const afterElOrder = parsedItems[to + 1]
    ? parsedItems[to + 1].order
    : parsedItems[to - 1].order + JUMP_ORDER;
  toEl.order = (beforeElOrder + afterElOrder) / 2;

  return parsedItems;
};

export const calculateOrderInReorderedList = (items, targetIndex) => {
  let newOrder;
  if (items.length === 1) {
    newOrder = 1024; // first element
  } else if (targetIndex === 0) {
    // move to first position
    newOrder = items[1].order / 2;
  } else if (targetIndex === items.length - 1) {
    // move to last position
    newOrder = items[targetIndex - 1].order + 1024;
  } else {
    // move between two elements
    const before = items[targetIndex - 1].order;
    const after = items[targetIndex + 1].order;
    newOrder = (before + after) / 2;
  }
  return newOrder;
};

export const calculateOrderFromOriginalList = (items, fromIndex, toIndex) => {
  if (fromIndex === toIndex) return items[fromIndex].order;
  if (items.length === 1) return items[0].order;

  // filter out the moved element to simulate the final list
  const withoutMoved = items.filter((_, index) => index !== fromIndex);

  let newOrder;
  if (toIndex === 0) {
    // move to first position
    newOrder = withoutMoved[0].order / 2;
  } else if (toIndex >= withoutMoved.length) {
    // move to last position
    newOrder = withoutMoved[withoutMoved.length - 1].order + JUMP_ORDER;
  } else {
    // move between two elements
    const before = withoutMoved[toIndex - 1].order;
    const after = withoutMoved[toIndex].order;
    newOrder = (before + after) / 2;
  }

  return newOrder;
};

export const createIdToObjectHashMap = arrayToMap =>
  new Map(arrayToMap.map(item => [item.id, item]));

export const recursiveSortItemsByName = items => {
  for (let i = 0; i < items?.length || 0; i++) {
    const node = items?.[i];
    if (node?.children) {
      node.children = recursiveSortItemsByName(node.children);
    }
  }
  return items?.sort((a, b) => a.name?.localeCompare(b.name));
};
